module.exports = {
      id: "google-play-usage",
      viewBox: undefined,
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#google-play",
      toString: function () {
        return this.url;
      }
    }